import { SuperInputBase } from "@components:SuperInput/SuperInput.Base";
import { SuperInputProps } from "@components:SuperInput/types";
import { TextField, TextFieldProps } from "@mui/material";
import { mergeObjects } from "@utils:object";

export type SuperInputTextFieldProps = SuperInputProps &
  TextFieldProps & {
    width?: string;
  };

export const SuperInputTextField = ({
  label,
  helperText,
  explainText,
  errorText,
  sx,
  width,
  required,
  autoHeight,
  ...props
}: SuperInputTextFieldProps) => {
  return (
    <SuperInputBase
      autoHeight={autoHeight}
      label={label}
      helperText={helperText}
      explainText={explainText}
      errorText={errorText}
      required={required}
      sx={sx}
    >
      <TextField
        {...props}
        className={"SuperInput__TextField with-bg"}
        /*
         * Do not set type='password' directly on TextField
         * https://stackoverflow.com/questions/48304062/material-ui-textfield-disable-browser-autocomplete
         */
        slotProps={mergeObjects(
          {
            htmlInput: {
              ...(props.type === "password" && {
                autoComplete: "new-password",
                type: "password",
              }),
            },
          },
          props.slotProps,
        )}
        sx={{
          width: width || "100%",
        }}
      />
    </SuperInputBase>
  );
};
